"use client";
import { PaylioContext } from "@/context/context";
import Image from "@/components/AppImage";
import { useContext, useEffect } from "react";
import LanguageArea from "../common/LanguageArea";
import NotificationsArea from "../common/NotificationsArea";
import ThemeToggle from "../common/ThemeToggle";
import UserArea from "../common/UserArea";
import LeftSideMenu from "../leftSideMenu/LeftSideMenu";
import menu from "/public/images/icon/menu.png";
import search from "/public/images/icon/search.png";

const NavBar = () => {
  const { activeLefMenu, setActiveLefMenu } = useContext(PaylioContext);

  const navBarTop = () => {};

  useEffect(() => {
    window.addEventListener("scroll", navBarTop);
    return () => {
      window.removeEventListener("scroll", navBarTop);
    };
  }, []);

  return (
    <header
      className={`header-section position-fixed ${
        activeLefMenu ? "body-collapse" : ""
      } `}>
      <div className="overlay">
        <div className="container-fruid">
          <div className="row d-flex header-area">
            <div className="navbar-area d-flex align-items-center justify-content-between">
              <div className="sidebar-icon">
                <Image
                  src={menu}
                  alt="icon"
                  onClick={() => setActiveLefMenu((prev) => !prev)}
                />
              </div>
              <form action="#" className="flex-fill">
                <div className="form-group d-flex align-items-center">
                  <Image src={search} alt="icon" />
                  <input
                    type="text"
                    placeholder="Search ACH, wallets, activity…"
                  />
                </div>
              </form>
              <div className="dashboard-nav">
                <ThemeToggle />

                {/* Language Area */}
                <LanguageArea />

                {/* Notifications Area */}
                <NotificationsArea />

                {/* User Area */}
                <UserArea />
              </div>
            </div>

            {/* Left Side Menu */}
            <LeftSideMenu />
          </div>
        </div>
      </div>
    </header>
  );
};

export default NavBar;
